import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { Button } from "reactstrap";
import MUIBoxTable from "../../../../../common/components/mui-table/mui-box-table";
import { Select, MenuItem } from "@mui/material";
import './assign-partner.scss';

interface TenantInfo {
  tenantId: number;
  companyName: string;
  currentPlan: string;
  selectedPlan: string;
  planType?: string;
}

const PlanTypePopup = ({
  open,
  tenants,
  onCancel,
  onSelect,
}: {
  open: boolean;
  tenants: TenantInfo[];
  onCancel: () => void;
  onSelect: (updatedTenants: TenantInfo[]) => void;
}) => {
  const [tenantSelections, setTenantSelections] = useState<TenantInfo[]>([]);

  useEffect(() => {
    setTenantSelections(
      tenants.map((t) => ({
        ...t,
        planType: t.planType || "",
      }))
    );
  }, [tenants]);

  const handlePlanTypeChange = (id: number, value: string) => {
    setTenantSelections((prev) =>
      prev.map((item) =>
        item.tenantId === id ? { ...item, planType: value } : item
      )
    );
  };

  const columns = [
    { label: "Company Name", key: "companyName" },
    { label: "Current Plan", key: "currentPlanName" },
    { label: "New Plan", key: "selectedPlanName" },
    {
      label: "Billing Cycle",
      key: "planType",
      disableTooltip: true,
      render: (row: TenantInfo) => (
        <Select
          fullWidth
          value={row.planType ?? ""}
          onChange={(e) => handlePlanTypeChange(row.tenantId, e.target.value)}
          displayEmpty
        >
          <MenuItem value="">
            <em>Select</em>
          </MenuItem>
          <MenuItem value="monthly">Monthly</MenuItem>
          <MenuItem value="annual">Yearly</MenuItem>
        </Select>
      ),
    },
  ];

  const isValid = tenantSelections.every((t) => t.planType !== "");

  return (
    <Dialog
      open={open}
      maxWidth="md"
      slotProps={{
        paper: {
          sx: {
            backgroundColor: "#f1f1f1",
          },
        },
      }}
    >
      <DialogTitle>Assign Plan Type</DialogTitle>

      <DialogContent>
        <div style={{ marginBottom: 10 }}>
          You selected <b>{tenantSelections.length}</b> partner(s). Choose
          billing cycle for each:
        </div>

        <div style={{ marginTop: 15 }}>
          <MUIBoxTable columns={columns} data={tenantSelections} />
        </div>
      </DialogContent>

      <DialogActions className="button-group">
        <Button onClick={onCancel} className="cancel-btn ">
          Cancel
        </Button>
        <Button
          color="primary"
          disabled={!isValid}
          onClick={() => onSelect(tenantSelections)}
          className="confirm-btn"
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PlanTypePopup;
